<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
export default {
	name: "App",
	metaInfo: {
		title: "Carlitur Casas Rodantes",
		titleTemplate: "%s | Carlitur Casas Rodantes"
	}
}
</script>
